import { useStripe, useElements, PaymentElement, CardElement } from '@stripe/react-stripe-js';
import { Button } from 'react-bootstrap';

const CheckoutForm = ({ successCB, loadingCB, failCB, clientSecret, paymentMethod }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        loadingCB(true);

        let payment_method = {
            payment_method: {
                card: elements.getElement(CardElement),
            },
        }
        if (paymentMethod) {
            payment_method = {
                payment_method: paymentMethod,
            };
        }
        const result = await stripe.confirmCardPayment(clientSecret, payment_method);

        if (result.error) {
            failCB(result.error);
        } else {
            successCB();
        }
        loadingCB(false);
    };
    return (
        <form>
            <div>
                Payments may take a few minutes to show.<br /><br />
            </div>
            {
                !paymentMethod &&
                <CardElement />
            }
            <Button className='w-75 btn btn-primary StripeValidateBtn' onClick={handleSubmit} disabled={!stripe}>Submit Payment</Button>
        </form>
    )
};

export default CheckoutForm;